// import React from "react";

// export default function ReactPayPal() {
//   const [paid, setPaid] = React.useState(false);
//   const [error, setError] = React.useState(null);
//   const paypalRef = React.useRef();

//   // To show PayPal buttons once the component loads
//   React.useEffect(() => {
//     window.paypal
//       .Buttons({
//         createOrder: (data, actions) => {
//           return actions.order.create({
//             intent: "CAPTURE",
//             purchase_units: [
//               {
//                 description: "Your description",
//                 amount: {
//                   currency_code: "USD",
//                   value: 0.02,
//                 },
//               },
//             ],
//           });
//         },
//         onApprove: async (data, actions) => {
//           const order = await actions.order.capture();
//           setPaid(true);
//           console.log(order);
//         },
//         onError: (err) => {
//         //   setError(err),
//           console.error(err);
//         },
//       })
//       .render(paypalRef.current);
//   }, []);

//   // If the payment has been made
//   if (paid) {
//     return <div>Payment successful.!</div>;
//   }

//   // If any error occurs
//   if (error) {
//     return <div>Error Occurred in processing payment.! Please try again.</div>;
//   }

//   // Default Render
//   return (
//     <div>
//       <h4>Total Amount in Rs. : 0.02 /-</h4>
//       <div ref={paypalRef} />
//     </div>
//   );
// }
import { PayPalButton } from "react-paypal-button-v2";
import React from 'react';

export function ReactPayPal (props){
  // render() {
    const paypalKey = this.context.state.paypal_client_id
    return (
      <PayPalButton
      options={{
        // clientId: paypalKey,
        // intent:"subscription",
        vault:false
        }}
        createOrder={(data, actions) => {
          return actions.order.create({
            intent: "CAPTURE",
            purchase_units: [{
              amount: {
                currency_code: "USD",
                value: "0.01"
              }
            }],
            // application_context: {
            //   shipping_preference: "NO_SHIPPING" // default is "GET_FROM_FILE"
            // }
          });
        }}
        onApprove={(data, actions) => {
          // Capture the funds from the transaction
          return actions.order.capture().then(function(details) {
            // Show a success message to your buyer
            alert("Transaction completed by " + details.payer.name.given_name);

            // OPTIONAL: Call your server to save the transaction
            // return fetch("/paypal-transaction-complete", {
            //   method: "post",
            //   body: JSON.stringify({
            //     orderID: data.orderID
            //   })
            // });
            console.log(details);
          });
        }}
      />
    );
  // }
}
export default ReactPayPal;


// WEBPACK FOOTER //
// ./src/components/PayPal/checkout/ReactPayPal.js